<template>
  <v-dialog
    persistent
    v-model="dialog"
    width="500px"
    height="200px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @click:outside="() => {}"
  >
    <v-card>
      <v-card-title>Xác nhận điểm danh học sinh</v-card-title>
      <v-card-text>
        <div style="margin-bottom: 10px">
          Để điểm danh cho tất các các học sinh đã chọn hãy chọn trạng thái bên dưới và xác nhận.
        </div>
        <div class="d-flex">
          <div v-if="status === 'present'">
            <v-btn
              :outlined="subStatus !== 'onTime'"
              color="success"
              class="mr-2"
              @click="() => updateSubStatus('onTime')"
              >Đúng giờ</v-btn
            >
            <v-btn :outlined="subStatus !== 'lateTime'" color="warning" @click="() => updateSubStatus('lateTime')"
              >Vào muộn</v-btn
            >
          </div>
          <div v-if="status === 'absent'">
            <v-btn
              :outlined="subStatus !== 'excused'"
              color="success"
              class="mr-2"
              @click="() => updateSubStatus('excused')"
              >Có phép</v-btn
            >
            <v-btn :outlined="subStatus !== 'unexcused'" color="warning" @click="() => updateSubStatus('unexcused')"
              >Không phép</v-btn
            >
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" color="primary" outlined light @click="clickCancel">Huỷ</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="subStatus === ''" color="primary" width="100px" class="elevation-0" @click="clickDone"
          >Xác nhận</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return { dialog: false, status: '', subStatus: '', done: () => {}, cancel: () => {} }
  },
  methods: {
    show({ status = '', done = () => {}, cancel = () => {} }) {
      this.dialog = true
      this.status = status
      this.subStatus = ''
      this.done = done
      this.cancel = cancel
    },
    updateSubStatus(subStatus) {
      this.subStatus = subStatus
    },
    clickDone() {
      this.done(this.subStatus)
      this.dialog = false
    },
    clickCancel() {
      this.cancel()
      this.dialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
.bold {
  font-weight: bold;
}
</style>
